<template>
  
    <!-- ========== Left Sidebar Start ========== -->
    <div class="leftside-menu">
        
        <!-- LOGO -->
        <a href="/" class="logo text-center logo-light">
            <span class="logo-lg">
                <img src="/images/fluend.png" alt="" height="16">
            </span>
            <span class="logo-sm">
                <img src="/images/fluend.png" alt="" height="16">
            </span>
        </a>

        <!-- LOGO -->
        <a href="/" class="logo text-center logo-dark">
            <span class="logo-lg">
                <img src="/images/fluend.png" alt="" height="24">
            </span>
            <span class="logo-sm">
                <img src="/images/fluend.png" alt="" height="16">
            </span>
        </a>
        
        <div class="h-100" id="leftside-menu-container" data-simplebar>

            <!--- Sidemenu -->
            <ul class="side-nav">

                <li class="side-nav-title side-nav-item">Navigation</li>

                <li class="side-nav-item">
                    <a data-bs-toggle="collapse" href="#sidebarDashboards" aria-expanded="false" aria-controls="sidebarDashboards" class="side-nav-link">
                        <i class="uil-laptop"></i>
                        <span> Dashboards </span>
                        <span class="menu-arrow"></span>
                    </a>
                    <div class="collapse" id="sidebarDashboards">
                        <ul class="side-nav-second-level">
                            <li v-if="([1,2,4]).includes($page.props.user.user_type_id)">
                                <a :href="route('company')">My company</a>
                            </li>
                            <li>
                                <a href="/">My Dashboard</a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="side-nav-item">
                    <a data-bs-toggle="collapse" href="#sidebarcoPipeline" aria-expanded="false" aria-controls="sidebarcoPipeline" class="side-nav-link">
                        <i class="uil-layer-group"></i>
                        <span> Pipeline </span>
                        <span class="menu-arrow"></span>
                    </a>
                    <div class="collapse" id="sidebarcoPipeline">
                        <ul class="side-nav-second-level">
                            <li>
                                <a :href="route('pipeline')">Pipeline</a>
                            </li>
                            <li>
                                <a :href="route('customers')">Customers</a>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="side-nav-item">
                    <a :href="route('projects')" class="side-nav-link">
                        <i class="uil-meeting-board"></i>
                        <span> My Projects </span>
                    </a>
                </li>

                <li class="side-nav-item">
                    <a href="/my-time" class="side-nav-link">
                        <i class="uil-stopwatch"></i>
                        <span> My Time </span>
                    </a>
                </li>

                <li class="side-nav-item">
                    <a href="#" class="side-nav-link">
                        <i class="uil-file-download-alt"></i>
                        <span> My Reports </span>
                    </a>
                </li>

                <li class="side-nav-item">
                    <a data-bs-toggle="collapse" href="#sidebarSettings" aria-expanded="false" aria-controls="sidebarSettings" class="side-nav-link">
                        <i class="uil-cog"></i>
                        <span> Settings </span>
                        <span class="menu-arrow"></span>
                    </a>
                    <div class="collapse" id="sidebarSettings">
                        <ul class="side-nav-second-level">
                            <li v-if="([1,2,4]).includes($page.props.user.user_type_id)">
                                <a :href="route('users')">Users</a>
                            </li>
                            <li v-if="([1,2,4]).includes($page.props.user.user_type_id)">
                                <a href="#">Targets</a>
                            </li>
                            <li>
                                <a :href="'/users/' + $page.props.user.id">User settings</a>
                            </li>
                        </ul>
                    </div>
                </li>
                
            </ul>


            <div class="clearfix"></div>

        </div>
        <!-- Sidebar -left -->

    </div>
    <!-- Left Sidebar End -->

</template>

<script>
export default {

}
</script>

<style>
.leftside-menu {
    width: 200px!important;
}
.logo {
    width: 200px!important;
}

</style>